import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiServiceSettingsElCountriesParams } from '@/apis/swaggers/v3/api/service-settings/service-settings-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiServiceSettingsElCountriesParams, unknown>

const fetchCountries = async (params: ApiServiceSettingsElCountriesParams) => {
  const { data } = await apiClient.v3.apiServiceSettingsElCountries(params);
  return checkApiResponse(data);
}

export const serviceSettingCountriesKeys = {
  all: [QUERY_KEY.apiServiceSettingsElCountries] as const,
  list: (params: ApiServiceSettingsElCountriesParams) => [...serviceSettingCountriesKeys.all, params] as const,
}

// 국가 목록은 사실상 불변 — 세션 내 재조회하지 않고 캐시도 회수하지 않는다.
const DEFAULT_OPTIONS = {
  staleTime: Infinity,
  gcTime: Infinity,
} as const

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(serviceSettingCountriesQueryOptions(params))` */
export const serviceSettingCountriesQueryOptions = (params: ApiServiceSettingsElCountriesParams) => ({
  queryKey: serviceSettingCountriesKeys.list(params),
  queryFn: () => fetchCountries(params),
  ...DEFAULT_OPTIONS,
})

export const useServiceSettingCountriesQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    ...DEFAULT_OPTIONS,
    queryKey: serviceSettingCountriesKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchCountries(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
